// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import {
    processEntityInput as processEntityInputLocker,
    processEntityOutput as processEntityOutputLocker
} from 'store/serializers/fragments/locker';
import { getIriFromObj } from 'utils/processors';
import {
    processEntityInput as processEntityInputExecSettings,
    processEntityOutput as processEntityOutputExecSettings
} from 'store/app/workmgmt/exec-settings';
import {
    processEntityInput as processEntityInputTask,
    processEntityOutput as processEntityOutputTask,
    sortTasksByParentPosition
} from 'store/app/workmgmt/task';
import { processEntityInput as processEntityInputNote, processEntityOutput as processEntityOutputNote } from 'store/app/workmgmt/note';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    ...processEntityInputSafeDeleter(values),
    ...processEntityInputLocker(values),
    execSettings: processEntityInputExecSettings(values?.execSettings),
    notes: values?.notes?.map((note) => processEntityInputNote(note))?.sort((n1, n2) => (n1.createdAt < n2.createdAt ? 1 : -1)),
    tasks: sortTasksByParentPosition(values?.tasks?.filter((task) => !task?.deletedAt)?.map((task) => processEntityInputTask(task)) || [])
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    ...processEntityOutputSafeDeleter(values),
    ...processEntityOutputLocker(values),
    color: undefined,
    metadata: undefined,
    businessOpportunityType: getIriFromObj(values?.businessOpportunityType) || null,
    department: getIriFromObj(values?.department) || null,
    client: getIriFromObj(values?.client) || null,
    responsible: getIriFromObj(values?.responsible) || null,
    participants:
        'participants' in (values || {}) && Array.isArray(values.participants)
            ? values.participants.map((part) => getIriFromObj(part) || null)
            : undefined,
    execSettings: processEntityOutputExecSettings(values?.execSettings),
    notes: 'notes' in (values || {}) && Array.isArray(values.notes) ? values.notes.map((note) => processEntityOutputNote(note)) : undefined,
    tasks:
        'tasks' in (values || {}) && Array.isArray(values.tasks)
            ? values.tasks.map((task) => processEntityOutputTask({ ...task, businessOpportunity: getIriFromObj(values) }))
            : undefined,
    workOrders:
        'workOrders' in (values || {}) && Array.isArray(values.workOrders)
            ? values.workOrders.map((workOrder) => getIriFromObj(workOrder) || null)
            : undefined
});
